export enum AllstateChannel {
  ALLSTATE_CHANNEL = 1,
  BROKER_CHANNEL = 2,
  NATIONAL_ACCOUNTS = 3,
}
